// Update profile URLs here when a social account changes.
export const socialLinks = {
  instagram: 'https://www.instagram.com/adelgomezmusic/',
  tiktok: 'https://www.tiktok.com/@theadelgomezband',
};
